import type { ChatMessageAttachment } from "@/features/chat/types";
import { fileExtension, isImageFilename } from "./types";

/** Minimalny wpis pliku, z którego da się zrobić podgląd zdjęcia (obie zakładki „Pliki"). */
export interface PreviewableFile {
  managed_file_id: string;
  filename: string;
  url: string | null;
  size_bytes?: number | null;
}

export interface ImageSeries {
  items: ChatMessageAttachment[];
  index: number;
}

/**
 * Seria zdjęć folderu do podglądu jak w GG (MediaLightbox: strzałki ←/→ po kolejnych
 * zdjęciach): wszystkie obrazy z adresem w kolejności listy, z indeksem klikniętego.
 * Null, gdy kliknięty plik nie ma adresu (czeka na skan) albo nie jest obrazem.
 */
export function imageSeries(entries: PreviewableFile[], clicked: PreviewableFile): ImageSeries | null {
  if (!clicked.url || !isImageFilename(clicked.filename)) return null;
  const images = entries.filter((e) => !!e.url && isImageFilename(e.filename));
  const index = images.findIndex((e) => e.managed_file_id === clicked.managed_file_id && e.url === clicked.url);
  if (index < 0) return null;
  return {
    items: images.map((e) => ({
      id: e.managed_file_id,
      original_filename: e.filename,
      content_type: `image/${fileExtension(e.filename) === "jpg" ? "jpeg" : fileExtension(e.filename)}`,
      size_bytes: e.size_bytes ?? null,
      url: e.url,
    })),
    index,
  };
}
